import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useGetBudgetCategories } from "@/services/queries/budgets";
import useBudgets from "@/store/use-budgets";
import Loading from "@/components/custom/loading";
import BudgetCardItem from "./budget-card-item";

const BudgetsByCategory = () => {
  const { t } = useTranslation();
  const { currentBudget } = useBudgets();
  const { data, isPending } = useGetBudgetCategories(currentBudget?.id ?? "", {
    enabled: !!currentBudget,
  });

  const budgetCategories = useMemo(() => {
    return data?.value || [];
  }, [data]);

  if (isPending) {
    return <Loading className="mt-10" />;
  }

  return (
    <div className="mt-8 px-5">
      <span className="text-[15px] font-medium text-white">
        {t("label.budget_by_categories")}
      </span>
      <div className="mt-4 flex flex-col gap-4">
        {budgetCategories.map((budget) => (
          <BudgetCardItem key={budget.id} {...budget} />
        ))}
      </div>
    </div>
  );
};

export default BudgetsByCategory;
